module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Arenas/images/command-center.09cdeda0.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Arenas/images/command-center.png
// module id = 2500
// module chunks = 11